"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngineerWarningFlag = void 0;
var EngineerWarningFlag;
(function (EngineerWarningFlag) {
    EngineerWarningFlag["HARVERST_ID_UNDEFINED"] = "Harvest id is undefined";
    EngineerWarningFlag["OFFBOARDED"] = "Engineer offboarded in Harvest";
    EngineerWarningFlag["REGION_IS_UNDEFINED"] = "Region is undefined";
    EngineerWarningFlag["TEAM_IS_UNDEFINED"] = "Team is undefined";
})(EngineerWarningFlag || (exports.EngineerWarningFlag = EngineerWarningFlag = {}));
//# sourceMappingURL=EngineerWarningFlag.js.map